import { useState } from 'react';
import { useLocation, useRevalidator } from 'react-router';

import { FloatingImageHolder } from '#/components/FloatingImageHolder/FloatingImageHolder';
import { StyledNativeLinkWithRef } from '#/components/Link/StyledNativeLinkWithRef';
import { IdealistLogo } from '#/components/Logo/IdealistLogo';
import { H4 } from '#/components/Text/H4';
import { Text } from '#/components/Text/Text';
import { EmailSignupFormContainer } from '#/containers/EmailSignupFormContainer';
import { LoginFormContainer } from '#/containers/LoginFormContainer';
import { useI18n } from '#/i18n/hooks/useI18n';
import { salariesFaqPath } from '#/modules/salary/routing/salary.paths';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import {
  SalariesExploreAuthPageBody,
  SalariesExploreAuthPageHolder,
  SalariesExploreAuthPageSidebar,
  SalariesExploreAuthPageSidebarImageHolder,
} from './SalariesExplorePageAuth.styled';

export function SalariesExplorePageAuth() {
  const { i18n } = useI18n();
  const [signupMode, setSignupMode] = useState(true);
  const location = useLocation();
  const redirectTo = `${location.pathname}${location.search}`;
  const revalidator = useRevalidator();

  return (
    <SalariesExploreAuthPageHolder>
      <SalariesExploreAuthPageBody>
        <div
          style={{
            marginInline: 'auto',
            paddingTop: 36,
            maxWidth: 480,
            width: 480,
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <IdealistLogo height={82} />
          </div>
          <H4
            style={{ marginBottom: '0.5em', textAlign: 'center', marginTop: 1 }}
          >
            {i18n('Sign up or log in to see what you could be earning!')}
          </H4>

          <Text
            styleAs="bodySmall"
            style={{ marginBottom: '1em', textAlign: 'center' }}
          >
            {i18n('Powered by Idealist’s database of nonprofit salaries.')}
          </Text>

          {signupMode && (
            <EmailSignupFormContainer
              analyticsTitle="[main] Salary report page - signup mode"
              usageContext="page"
              loginOverrideFn={() => {
                setSignupMode(false);
              }}
              redirectTo={redirectTo}
              onSignup={() => {
                void revalidator.revalidate();
              }}
            />
          )}

          {!signupMode && (
            <LoginFormContainer
              analyticsTitle="[main] Salary report page"
              usageContext="page"
              signUpOverrideFn={() => {
                setSignupMode(true);
              }}
              redirectTo={redirectTo}
              email={null}
              inviteId={null}
              initialWarning={null}
              onLogin={() => {
                void revalidator.revalidate();
              }}
            />
          )}
        </div>

        <div style={{ marginTop: 72 }}>
          <div style={{ marginInline: 'auto', maxWidth: 480 }}>
            <Text styleAs="bodySmall" style={{ marginTop: '1em' }}>
              <Text styleAs="h5" tag="span">
                {
                  /* TRANSLATORS: Salary explorer footer */ i18n(
                    'We take data security very seriously. ',
                  )
                }
              </Text>
              <span>
                {i18n(`The information you enter in the survey will not be linked to your
          user account, and will be completely anonymized. `)}
              </span>
              {
                /* TRANSLATORS: Salary explorer footer */ i18n(
                  'Want to know more? ',
                )
              }
              {
                /* TRANSLATORS: Salary explorer footer */ i18n(
                  `{{link}}Learn more in our FAQ{{/link}} about how we protect your privacy.`,
                  {
                    link: (
                      <StyledNativeLinkWithRef
                        target="_blank"
                        href={salariesFaqPath.fullPath}
                      />
                    ),
                  },
                )
              }
            </Text>
          </div>
        </div>
      </SalariesExploreAuthPageBody>

      <SalariesExploreAuthPageSidebar>
        <SalariesExploreAuthPageSidebarImageHolder>
          <FloatingImageHolder>
            <img
              src={getStaticImageSrc('compdb/survey-step1.svg')}
              width={270}
              height={282}
              alt=""
            />
          </FloatingImageHolder>
        </SalariesExploreAuthPageSidebarImageHolder>
      </SalariesExploreAuthPageSidebar>
    </SalariesExploreAuthPageHolder>
  );
}
